import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import MUILink from "@mui/material/Link";
import NextJSLink from "next/link";
import React from "react";
export { ActiveLink } from "./active";
export { ContrastLink } from "./contrast";
export { ImperceptibleLink } from "./imperceptible";
export var Link = function(_param) /*#__PURE__*/ {
    var children = _param.children, className = _param.className, target = _param.target, rel = _param.rel, _underline = _param.underline, underline = _underline === void 0 ? "none" : _underline, rest = _object_without_properties(_param, [
        "children",
        "className",
        "target",
        "rel",
        "underline"
    ]);
    return _jsx(NextJSLink, _object_spread_props(_object_spread({
        passHref: true
    }, rest), {
        children: /*#__PURE__*/ _jsx(MUILink, {
            className: className,
            color: "inherit",
            target: target,
            rel: rel,
            underline: underline,
            children: children
        })
    }));
};
export default Link;
